import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("cq_lang") || "it");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "it" ? "en" : "it";
      localStorage.setItem("cq_lang", next);
      return next;
    });
  }, []);

  const t = translations[lang];
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
